// ICONS
export { default as ArrowRight } from './images/icons/ArrowRight';
export { default as Cross } from './images/icons/Cross';
export { default as Hamburger } from './images/icons/Hamburger';
export { default as Linkedin } from './images/icons/Linkedin';
export { default as X } from './images/icons/X';
export { default as Plus } from './images/icons/Plus';
export { default as Content } from './images/icons/Content';
export { default as Data } from './images/icons/Data';
export { default as Expertise } from './images/icons/Expertise';
export { default as ChevronDown } from './images/icons/ChevronDown';

// BACKGROUNDS
export { default as FeaturesBackgroundRight } from './images/backgrounds/features-background-right.svg';
export { default as FeaturesBackgroundLeft } from './images/backgrounds/features-background-left.svg';
export { default as HeroBackgroundMobile } from './images/backgrounds/hero-background-gradient-mobile.svg';
export { default as HeroBackgroundGradientXL } from './images/backgrounds/hero-background-gradient-xl.svg';
export { default as HeroBackgroundGradientDesktop } from './images/backgrounds/hero-backgrund-gradient-desktop.svg';
export { default as LobbyBackground } from './images/backgrounds/lobby-background.svg';
export { default as QuotesBackground } from './images/backgrounds/quotes-background.svg';
export { default as TeamBackground } from './images/backgrounds/team-background.svg';
export { default as TeamGrid } from './images/backgrounds/team-grid.svg';
export { default as PartnersBackground } from './images/backgrounds/partners-background.svg';

// LOBBY
export { default as TrophyBadge } from './images/lobby/trophy-badge.png';
export { default as StarBadge } from './images/lobby/star-badge.png';
export { default as BrandNewBadge } from './images/lobby/brand-new-badge.svg';
export { default as LobbyPhone } from './images/lobby/lobby-phone.webp';
export { default as LobbyPhone2 } from './images/lobby/lobby-phone-2.webp';

// FEATURES
export { default as FeaturePhone1 } from './images/features/phone-1.webp';
export { default as FeaturePhone2Dark } from './images/features/phone-2-dark.webp';
export { default as FeaturePhone2Light } from './images/features/phone-2-light.webp';
export { default as FeaturePhone3 } from './images/features/phone-3.webp';
export { default as FeaturePhone4 } from './images/features/phone-4.webp';
export { default as MedalBadge } from './images/features/medal-badge.svg';
export { default as DollarBadge } from './images/features/dollar-badge.svg';
export { default as EuroBadge } from './images/features/euro-badge.svg';
export { default as LanguageBadge } from './images/features/language-badge.svg';
export { default as ESL } from './images/features/ESL.webp';
export { default as G2 } from './images/features/G2.png';
export { default as Tennis } from './images/features/tennis.png';
export { default as AmericanFootball } from './images/features/american-football.png';
export { default as ArrowCursor } from './images/features/arrow-cursor.svg';
export { default as Prize10000 } from './images/features/prize-10000.webp';
export { default as Banner } from './images/features/banner.webp';
export { default as LanguageDropdown } from './images/features/language-dropdown.webp';

// LOGOS
export { default as AltLogo } from './images/logos/alt-logo.svg';
export { default as MainLogo } from './images/logos/main-logo.svg';
export { default as Altenar } from './images/logos/altenar.png';
export { default as AppsFlyer } from './images/logos/appsFlyer.png';
export { default as Arland } from './images/logos/arland.png';
export { default as BtoBet } from './images/logos/btoBet.png';
export { default as CaptainUp } from './images/logos/captainUp.png';
export { default as Fastrack } from './images/logos/fastrack.png';
export { default as Firebase } from './images/logos/firebase.png';
export { default as Jumpman } from './images/logos/jumpman.png';
export { default as Kambi } from './images/logos/kambi.png';
export { default as OpenBet } from './images/logos/openBet.png';
export { default as Optimove } from './images/logos/optimove.png';
export { default as Salesforce } from './images/logos/salesforce.png';
export { default as Twilio } from './images/logos/twilio.png';
export { default as XtremePush } from './images/logos/xtremepush.png';
export { default as SwitchAnalytics } from './images/logos/switchAnalytics.png';
export { default as Bragg } from './images/logos/bragg.png';
export { default as Gig } from './images/logos/gig.png';
export { default as Evona } from './images/logos/Evona.svg';
export { default as Jacks } from './images/logos/jacks.svg';
export { default as JacksTestimonial } from './images/logos/jacks-testimonial.svg';
export { default as TenBet } from './images/logos/10Bet.svg';
export { default as Sport888 } from './images/logos/888sport.svg';
export { default as B2Tech } from './images/logos/b2Tech.svg';
export { default as ComeOn } from './images/logos/comeOn.svg';
export { default as PrideBet } from './images/logos/prideBet.svg';
export { default as PrideBetTestimonial } from './images/logos/prideBet-testimonial.svg';
export { default as GOAT } from './images/logos/GOAT.svg';
export { default as Lucky7Ventures } from './images/logos/lucky7Ventures.svg';
export { default as PremierBet } from './images/logos/premierBet.svg';
export { default as EstrelaBet } from './images/logos/EstrelaBet.svg';
export { default as BetToMax } from './images/logos/BetToMax.svg';
export { default as Rootz } from './images/logos/Rootz.svg';
export { default as Bingoal } from './images/logos/Bingoal.svg';
export { default as RubyPlay } from './images/logos/RubyPlay.png';
export { default as BetPlay } from './images/logos/BetPlay.png';
export { default as BoaBet } from './images/logos/BoaBet.png';
export { default as EsportivaBet } from './images/logos/Esportiva-Bet.png';
export { default as LottoLandLogo } from './images/logos/LottoLand-Logo.png';
export { default as MrBit } from './images/logos/MrBit.png';
export { default as MrQ } from './images/logos/MrQ.png';
export { default as Yeet } from './images/logos/Yeet.png';
export { default as Yuugado } from './images/logos/Yuugado.png';

// FLAGS
export { default as England } from './images/flags/england.svg';
export { default as Finland } from './images/flags/finland.svg';
export { default as France } from './images/flags/france.svg';
export { default as Germany } from './images/flags/germany.svg';
export { default as India } from './images/flags/india.svg';
export { default as Italy } from './images/flags/italy.svg';
export { default as Japan } from './images/flags/japan.svg';
export { default as Kenya } from './images/flags/kenya.svg';
export { default as Netherlands } from './images/flags/netherlands.svg';
export { default as Norway } from './images/flags/norway.svg';
export { default as Poland } from './images/flags/poland.svg';
export { default as Portugal } from './images/flags/portugal.svg';
export { default as SaudiArabia } from './images/flags/saudi-arabia.svg';
export { default as Spain } from './images/flags/spain.svg';
export { default as Ukraine } from './images/flags/ukraine.svg';
export { default as USA } from './images/flags/usa.svg';

// TEAM
export { default as Jose } from './images/team/jose.webp';
export { default as Adam } from './images/team/adam.webp';
export { default as Marc } from './images/team/marc.webp';
export { default as Marko } from './images/team/marko.webp';
export { default as Ricky } from './images/team/ricky.webp';
export { default as Ben } from './images/team/ben.webp';
export { default as Chris } from './images/team/chris.webp';
export { default as Iryna } from './images/team/Iryna.webp';
export { default as Bonham } from './images/team/bonham.webp';
export { default as Liliia } from './images/team/liliia.webp';
export { default as Jack } from './images/team/jack.webp';
export { default as Paul } from './images/team/paul.webp';
export { default as Lorraine } from './images/team/Lorraine.webp';
export { default as Nemanja } from './images/team/Nemanja.webp';
export { default as Nicholas } from './images/team/Nicholas.webp';
export { default as Davi } from './images/team/Davi.webp';
export { default as Andrej } from './images/team/Andrej.webp';

// FOOTER
export { default as Sticker1 } from './images/stickers/sticker-1.svg';
export { default as Sticker2 } from './images/stickers/sticker-2.svg';
export { default as Sticker3 } from './images/stickers/sticker-3.svg';
export { default as Sticker4 } from './images/stickers/sticker-4.svg';
export { default as Sticker5 } from './images/stickers/sticker-5.svg';
export { default as Sticker6 } from './images/stickers/sticker-6.svg';
export { default as Sticker7 } from './images/stickers/sticker-7.svg';
export { default as Sticker8 } from './images/stickers/sticker-8.svg';

// GAMES SPORTS - Icons
export { default as AmericanFootballIcon } from './images/games/Sports/icons/American-Football.png';
export { default as BaseballIcon } from './images/games/Sports/icons/Baseball.png';
export { default as BasketballIcon } from './images/games/Sports/icons/Basketball.png';
export { default as FootballIcon } from './images/games/Sports/icons/Football.png';
export { default as IceHockeyIcon } from './images/games/Sports/icons/Ice-Hockey.png';
export { default as MMAIcon } from './images/games/Sports/icons/MMA.png';
export { default as TennisIcon } from './images/games/Sports/icons/Tennis.png';

// GAMES SPORTS - American Football
export { default as AmFootballCoupon } from './images/games/Sports/American Football/Coupon.webp';
export { default as AmFootballDoubleWheel } from './images/games/Sports/American Football/Double Wheel.webp';
export { default as AmFootballQuiz } from './images/games/Sports/American Football/Quiz.webp';
export { default as AmFootballTotalTDs } from './images/games/Sports/American Football/Total TDs.webp';

// GAMES SPORTS - Baseball
export { default as BaseballCoupon } from './images/games/Sports/Baseball/Coupon.webp';
export { default as BaseballDoubleWheel } from './images/games/Sports/Baseball/Double Wheel.webp';
export { default as BaseballQuiz } from './images/games/Sports/Baseball/Quiz.webp';
export { default as BaseballTotalRuns } from './images/games/Sports/Baseball/Total Runs.webp';

// GAMES SPORTS - Basketball
export { default as BasketballCoupon } from './images/games/Sports/Basketball/Coupon.webp';
export { default as BasketballDoubleWheel } from './images/games/Sports/Basketball/Double Wheel.webp';
export { default as BasketballQuiz } from './images/games/Sports/Basketball/Quiz.webp';
export { default as BasketballTotalPoints } from './images/games/Sports/Basketball/Total Points.webp';

// GAMES SPORTS - Football
export { default as FootballCoupon } from './images/games/Sports/Football/Coupon.webp';
export { default as FootballDoubleWheel } from './images/games/Sports/Football/Double Wheel.webp';
export { default as FootballPick6 } from './images/games/Sports/Football/Pick6.webp';
export { default as FootballQuiz } from './images/games/Sports/Football/Quiz.webp';
export { default as FootballTotalGoals } from './images/games/Sports/Football/Total Goals.webp';

// GAMES SPORTS - Ice Hockey
export { default as IceHockeyCoupon } from './images/games/Sports/Ice Hockey/Coupon.webp';
export { default as IceHockeyDoubleWheel } from './images/games/Sports/Ice Hockey/Double Wheel.webp';
export { default as IceHockeyPick6 } from './images/games/Sports/Ice Hockey/Pick6.webp';
export { default as IceHockeyQuiz } from './images/games/Sports/Ice Hockey/Quiz.webp';
export { default as IceHockeyTotalGoals } from './images/games/Sports/Ice Hockey/Total Goals.webp';

// GAMES SPORTS - MMA
export { default as MMACoupon } from './images/games/Sports/MMA/Coupon.webp';
export { default as MMAQuiz } from './images/games/Sports/MMA/Quiz.webp';
export { default as MMATotalRounds } from './images/games/Sports/MMA/Total Rounds.webp';

// GAMES SPORTS - Tennis
export { default as TennisCoupon } from './images/games/Sports/Tennis/Coupon.webp';
export { default as TennisDoubleWheel } from './images/games/Sports/Tennis/Double Wheel.webp';
export { default as TennisQuiz } from './images/games/Sports/Tennis/Quiz.webp';
export { default as TennisTotalGoals } from './images/games/Sports/Tennis/Total Goals.webp';

// GAMES CASINO
export { default as CasinoClassicWheel } from './images/games/Casino/phone.webp';
export { default as CasinoPrizeDrop } from './images/games/Casino/prize_drop.webp';
export { default as CasinoProgressiveBoardGame } from './images/games/Casino/progressive_board_game.webp';
export { default as CasinoReels } from './images/games/Casino/reels.webp';
export { default as CasinoScratchCard } from './images/games/Casino/scratch_card.webp';
export { default as CasinoTrippleWheel } from './images/games/Casino/tripple_wheel.webp';

// GAMES JACKPOTS
export { default as Jackpot1 } from './images/games/Jackpots/Jackpots.webp';
export { default as Jackpot2 } from './images/games/Jackpots/Jackpots 2.webp';
export { default as Jackpot3 } from './images/games/Jackpots/Jackpots 3.webp';
